// extracted by css-extract-rspack-plugin
module.exports =  {"root":"UserManagement__root___JL5vy"};